import moment from "moment";

export const settingsConstants = {
  frequencyOptions: [
    { value: "weekly", label: "Weekly" },
    { value: "bi-weekly", label: "Bi-Weekly" },
    { value: "monthly", label: "Monthly" },
    { value: "other", label: "Other" },
  ],
  dayOptions: [
    {
      value: moment("Monday", "dddd").weekday(),
      label: "Monday",
    },
    {
      value: moment("Tuesday", "dddd").weekday(),
      label: "Tuesday",
    },
    {
      value: moment("Wednesday", "dddd").weekday(),
      label: "Wednesday",
    },
    {
      value: moment("Thursday", "dddd").weekday(),
      label: "Thursday",
    },
    {
      value: moment("Friday", "dddd").weekday(),
      label: "Friday",
    },
    {
      value: moment("Saturday", "dddd").weekday(),
      label: "Saturday",
    },
    {
      value: moment("Sunday", "dddd").weekday(),
      label: "Sunday",
    },
  ],
  timeOptions: [
    { value: "00:00", label: "12:00am" },
    { value: "00:30", label: "12:30am" },
    { value: "01:00", label: "01:00am" },
    { value: "01:30", label: "01:30am" },
    { value: "02:00", label: "02:00am" },
    { value: "02:30", label: "02:30am" },
    { value: "03:00", label: "03:00am" },
    { value: "03:30", label: "03:30am" },
    { value: "04:00", label: "04:00am" },
    { value: "04:30", label: "04:30am" },
    { value: "05:00", label: "05:00am" },
    { value: "05:30", label: "05:30am" },
    { value: "06:00", label: "06:00am" },
    { value: "06:30", label: "06:30am" },
    { value: "07:00", label: "07:00am" },
    { value: "07:30", label: "07:30am" },
    { value: "08:00", label: "08:00am" },
    { value: "08:30", label: "08:30am" },
    { value: "09:00", label: "09:00am" },
    { value: "09:30", label: "09:30am" },
    { value: "10:00", label: "10:00am" },
    { value: "10:30", label: "10:30am" },
    { value: "11:00", label: "11:00am" },
    { value: "11:30", label: "11:30am" },
    { value: "12:00", label: "12:00pm" },
    { value: "12:30", label: "12:30pm" },
    { value: "13:00", label: "1:00pm" },
    { value: "13:30", label: "1:30pm" },
    { value: "14:00", label: "2:00pm" },
    { value: "14:30", label: "2:30pm" },
    { value: "15:00", label: "3:00pm" },
    { value: "15:30", label: "3:30pm" },
    { value: "16:00", label: "4:00pm" },
    { value: "16:30", label: "4:30pm" },
    { value: "17:00", label: "5:00pm" },
    { value: "17:30", label: "5:30pm" },
    { value: "18:00", label: "6:00pm" },
    { value: "18:30", label: "6:30pm" },
    { value: "19:00", label: "7:00pm" },
    { value: "19:30", label: "7:30pm" },
    { value: "20:00", label: "8:00pm" },
    { value: "20:30", label: "8:30pm" },
    { value: "21:00", label: "9:00pm" },
    { value: "21:30", label: "9:30pm" },
    { value: "22:00", label: "10:00pm" },
    { value: "22:30", label: "10:30pm" },
    { value: "23:00", label: "11:00pm" },
    { value: "23:30", label: "11:30pm" },
  ],
};

export const blogPosts = {
  introToOutro: "https://medium.com/@taykcrane/an-intro-to-outro-c4c0d69feb18",
  resetOnRetros:
    "https://medium.com/@taykcrane/hitting-reset-on-retros-79a4f82f34e6",
};



// WEBPACK FOOTER //
// ./src/shared/_constants.js